import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

const getLanguageScores = async () => {
  const { data } = await getRequest(API.GET.getLanguageScores);

  return mapLanguageScores(data?.data);
};

export const useGetLanguageScores = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.LANGUAGE_SCORES],
    queryFn: () => getLanguageScores(),
    staleTime: 1000 * 60 * 60,
    ...config,
  });
};

const mapLanguageScores = (
  data: {
    attributes: UCM.LanguageScoresRawType;
    id: string;
  }[],
): UCM.LanguageScoresType[] => {
  if (!data) return [];

  return data.map(({ attributes, id }) => ({
    label: attributes.name,
    value: attributes.score.toString() ?? '',
    id,
  }));
};
